exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popper[x-placement^=bottom] .popper__arrow{top:0!important;border:none}.el-dropdown-menu__item:not(.is-disabled):hover{background-color:#f6f7fa!important;color:#1b2733!important}.el-dropdown-menu{padding:8px 0}", ""]);

// exports
